export default "__VITE_ASSET__8e82a683__"